import { render, staticRenderFns } from "./ViTeacherAcademicManagementCurriculum.vue?vue&type=template&id=ddd8eafc"
import script from "./ViTeacherAcademicManagementCurriculum.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementCurriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports